import type { InfiniteData } from "@tanstack/react-query";

import { queryClient } from "./ReactQueryProvider";

class QueryBroadcastChannel {
  private static channelId = "QUERY_BRADCAST_CHANNEL";
  private static channel: BroadcastChannel | null = null;

  public static getChannel(): BroadcastChannel {
    if (QueryBroadcastChannel.channel === null) {
      QueryBroadcastChannel.channel = new BroadcastChannel(QueryBroadcastChannel.channelId);
    }
    return QueryBroadcastChannel.channel;
  }
}

export const queryBroadcastChannel = QueryBroadcastChannel.getChannel();

// 현재 탭에서 쿼리 캐시를 삭제하기 위한 함수
export function invalidateQueriesCurrentTab(queryKey: string[]) {
  queryClient.invalidateQueries({ queryKey });
}

// 다른 탭에서 쿼리 캐시를 삭제하기 위한 함수 (스킴링크로 띄운 새 탭)
export function invalidateQueriesOtherTabs(queryKey: string[]) {
  queryBroadcastChannel.postMessage(queryKey);
}

// useInfiniteQuery 결과에서 pages의 items를 평탄화하고 total을 함께 반환
export function flattenInfiniteQueryResult<T>(
  data: InfiniteData<{
    items: T[];
    total?: number;
  }>,
) {
  const total = data.pages[0]?.total ?? 0;
  const list = data.pages.flatMap((page) => page.items ?? []);

  return { total, list };
}
